import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		minHeight: 0,
		boxSizing: 'border-box'
	},
	tabsContainer: {
		backgroundColor: theme.palette?.primary?.main,
		color: theme.palette?.primary?.contrastText || '#fff',
		boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
		overflow: 'hidden'
	},
	tabs: {
		minHeight: 48,
		'& .MuiTabs-scrollButtons.Mui-disabled': {
			opacity: 0,
			width: 0,
			padding: 0,
			overflow: 'hidden'
		},
		'& .MuiTab-root': {
			color: '#d5d2d5',
			minWidth: 'max-content',
			paddingLeft: 12,
			paddingRight: 12,
			whiteSpace: 'nowrap',
			textTransform: 'uppercase',
			fontSize: '0.875rem',
			letterSpacing: '0.02em'
		},
		'& .Mui-selected': {
			color: '#fff !important',
			fontSize: '0.875rem'
		},
		'& .MuiTabs-indicator': {
			backgroundColor: '#fff'
		}
	},
	tabsFitted: {
		'& .MuiTabs-flexContainer': {
			width: '100%'
		},
		'& .MuiTab-root': {
			flex: '1 1 max-content',
			maxWidth: 'none'
		}
	},
	tabsMeasuring: {
		'& .MuiTabs-flexContainer': {
			width: 'max-content'
		},
		'& .MuiTab-root': {
			flex: '0 0 auto',
			maxWidth: 'none'
		}
	},
	tabPanel: {
		backgroundColor: theme.palette?.background?.paper || '#fff',
		border: theme.dialogs?.border,
		borderRadius: '5px',
		boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
		marginTop: '1rem',
		flex: '1 1 auto',
		minHeight: 0,
		overflowX: 'hidden',
		overflowY: 'scroll'
	},
	terminalContainer:{
		height:'100%',
		overflowY:'auto'
	},
	terminalTab:{
		overflow:'hidden',
		height:'100%',
		'& .MuiBox-root':{
			overflow:'hidden',
			boxSizing:'border-box',
			height:'100%',
		}
	},
	offlineContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		textAlign: 'center',
		padding: '3rem 1.5rem',
		gap: '0.75rem'
	},
	offlineIcon: {
		fontSize: '3rem',
		color: theme.palette?.text?.secondary || '#9e9e9e'
	},
	offlineBody: {
		maxWidth: '28rem',
		color: theme.palette?.text?.secondary || '#616161'
	}
}));

export default useStyles;
